import { reportApi } from './../api/system/index'

const track = {
  beforeMount(el: any, binding: any) {
    el.reportData = binding.value
    el.__handleClick__ = handleClick.bind(el) // 保存绑定的点击处理函数
    el.addEventListener('click', el.__handleClick__)
  },
  updated(el: any, binding: any) {
    el.reportData = binding.value
  },
  unmounted(el: any) {
    el.removeEventListener('click', el.__handleClick__)
  },
}

async function handleClick(this: any) {
  const { eventCode, extensions } = this.reportData
  const headers = {
    optionsType: 'EVENT',
  }
  extensions.TerminalType = 'H5'
  await reportApi({ eventCode, extensions }, headers)
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('track', track)
})
